@use "/src/styles/functions.scss";

.hint-text {
  display: flex;
  gap: functions.toRem(6);
  align-items: center;
}
